<template>
    <div
        v-touch:start="bindClick"
        v-if="dataStep.step === 'building' || dataStep.step === 'flat' || dataStep.step === 'parking'"
        :class="['visual-pinchzoom', {'is-hidden': !isPinch}]"
    >
        <div class="visual-pinchzoom__img">
            <iconHand/>
        </div>
    </div>
</template>
<style lang='scss'>
    @import "Pinchzoom";
</style>
<script>
import {mapActions, mapGetters} from 'vuex';
import iconHand from '../Icons/icon-pinch-hand';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';

Vue.use(Vue2TouchEvents);

export default {
    components: {
        iconHand
    },

    computed: {
        ...mapGetters({
            isPinch : 'GET_IS_PINCH',
            dataStep: 'GET_DATA_STEP'
        })
    },

    methods: {
        ...mapActions(['changeStatePinch']),

        bindClick() {
            this.changeStatePinch(false);
        }
    }
};
</script>
